export default __webpack_public_path__ + "static/constat_es-54d3d99335e557ab454e61a9d5c94230.mp4";